import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ElementRef,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { SemTextInputComponent } from "../sem-text-input/sem-text-input.component";
import { ValueAccessorBase } from "../shared/value-accessor/value-accessor-base";
import { registerLocaleData } from "@angular/common";
import localeAzCa from "@angular/common/locales/az";
import localeAzCaExtra from "@angular/common/locales/extra/az";
import moment from "moment";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MatMomentDateModule,
} from "@angular/material-moment-adapter";
import * as _ from "lodash";

import { FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { SemDateFormatPipePipe } from "../../../shared/helpers/pipes/sem-date-format-pipe.pipe";
import {
  SemSharedModule,
  MY_FORMATS,
} from "src/app/shared/modules/sem-shared/sem-shared.module";
import { TranslationsProviderService } from "src/app/services/translations-provider/translations-provider.service";
import { MatDatepicker } from "@angular/material/datepicker";

@Component({
  selector: "sem-date-picker",
  templateUrl: "./sem-date-picker.component.html",
  styleUrls: ["./sem-date-picker.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SemDatePickerComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class SemDatePickerComponent
  extends ValueAccessorBase<string>
  implements OnInit, AfterViewInit
{
  @Input() templateType: string;
  @Input() format: string;
  @Input() setDisabled: boolean = false;
  @Input() defaultValue: string;
  @Input() maxDate: string;
  @Input() minDate: string;
  @Input() maxDateToday: boolean = false;
  @Input() minDateToday: boolean = false;
  @Input() dateTimePicker: boolean = false;

  @ViewChild("picker", { read: ElementRef, static: false }) picker: ElementRef;
  @ViewChild("input", { read: ElementRef, static: false }) el: ElementRef;

  type: string;
  view: string;
  pickerOpen: boolean = false;

  minDateValue: Date | null = null;
  maxDateValue: Date | null = null;

  super() {}

  ngOnInit() {
    //registerLocaleData(localeAzCa, localeAzCaExtra);
    //MY_FORMATS.display.dateInput = this.format;
    /*this.dfms._modelValueSubmitValidator.subscribe(data => {
      this.dfms?.globalForm?.controls[this.getAttribute("name")]?.setValue(this.value);
      this.dfms?.globalForm?.controls[this.getAttribute("name")]?.updateValueAndValidity();
    });*/
  }

  ngAfterViewInit() {
    try {
      if (this.minDate && this.minDate.length > 0) {
        var splits = this.minDate.split(".");
        this.minDateValue = new Date(
          parseInt(splits[2]),
          parseInt(splits[1]) - 1,
          parseInt(splits[0]),
        );
      }
      if (this.maxDate && this.maxDate.length > 0) {
        var splits = this.maxDate.split(".");
        this.maxDateValue = new Date(
          parseInt(splits[2]),
          parseInt(splits[1]) - 1,
          parseInt(splits[0]),
        );
      }
      if (this.maxDateToday === true) {
        this.maxDateValue = new Date();
      }
      if (this.minDateToday === true) {
        this.minDateValue = new Date();
      }
    } catch (e) {
      //Date parse error, min and max should be in the following format: D.m.YYYY, example 31.2.2024
    }

    if (
      typeof this.templateType != "undefined" &&
      this.templateType.length > 0
    ) {
      var splited = this.templateType.split("_");
      this.type = splited[0];
      this.view = splited[1];
    }

    this.getDefaultValue();
    //this.picker.nativeElement.nativeElement.nativeElement.style.zoom = "0.3";
  }

  /*onTextChange(value:moment.Moment) {
    this.value = value.utc().toJSON();
  }*/

  onPickerOpened() {
    this.pickerOpen = true;
    this.preventBlur();
  }

  onPickerClosed() {
    this.pickerOpen = false;
    this.focusOut(this.value);
  }

  onTextChange(value) {
    try {
      if (this.el) {
        if (this.el.nativeElement.value.length > 0) {
          if (
            this.el.nativeElement.value[
              this.el.nativeElement.value.length - 1
            ] != "."
          ) {
            if (this.el.nativeElement.value.length == 2) {
              this.el.nativeElement.value = this.el.nativeElement.value + ".";
            } else if (
              this.el.nativeElement.value.length == 5 &&
              this.el.nativeElement.value.split(".").length < 3
            ) {
              this.el.nativeElement.value = this.el.nativeElement.value + ".";
            }
          }
        }
      }
    } catch (e) {}

    let val = value;
    try {
      if (value) {
        val = value.toDate();
      }
    } catch (e) {}

    this.value = val;
    this.utility.newSectionAdded.next(this.dfms.globalModel);

    let attName = this.getAttribute("name");
    const bindingName = this.getBindingPropertyName();
    const control = this.dfms?.globalForm?.controls?.[attName];
    if (control !== null && typeof control !== "undefined") {
      control.setValue(val);
      control.updateValueAndValidity();
    }

    this.dfms.updateControlsValidationArray(attName, val);
    if (this.dfms?.globalModel) {
      if (attName) {
        this.dfms.assign(this.dfms.globalModel, attName, val, true);
      }
      if (bindingName && bindingName !== attName) {
        this.dfms.assign(this.dfms.globalModel, bindingName, val, true);
      }
    }
    //console.log("datepicker value" + this.value);

    if (
      typeof this.onValueChangeEval != "undefined" &&
      this.onValueChangeEval
    ) {
      eval(this.onValueChangeEval);
    }
  }

  getDefaultValue() {
    if (
      (this.value == null || typeof this.value == "undefined") &&
      this.defaultValue != null &&
      typeof this.defaultValue != "undefined" &&
      this.defaultValue.length > 0
    ) {
      if (this.defaultValue == "today") {
        let val = new Date().toISOString();
        let val2: any = moment.utc();
        this.onTextChange(val2);
      } else {
        if (
          this.defaultValue.startsWith("${") &&
          this.defaultValue.endsWith("}")
        ) {
          //interpolate
          // use custom delimiter ${ }
          try {
            _.templateSettings.interpolate = /\${([\s\S]+?)}/g;
            let formModel = this.dfms.globalModel;

            if (formModel != null && typeof formModel != "undefined") {
              let compiled = _.template(this.defaultValue);
              let compiledValue = compiled(formModel);
              if (
                compiledValue != null &&
                compiledValue != "" &&
                typeof compiledValue != "undefined"
              ) {
                this.value = compiledValue;
              }
            }
          } catch (e) {}
        } else {
          // defaultValue should be specified in iso for example "2020-10-10T00:00:00.000Z"
          this.value = this.defaultValue;
        }
      }
    }

    return this.value;
  }

  afterPickerOpen() {}

  input(value) {
    //this.value = moment(value.toJSON()).format(this.format);
  }

  valueChanged() {
    //var dateFormatPipe = new SemDateFormatPipePipe("az");
    //this.value = dateFormatPipe.transform(this.value, "dd.MM.yyyy");
  }

  preventBlur() {
    setTimeout(() => {
      if (!this.el?.nativeElement) return;
      const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
      input.focus();
      input.select();
    }, 500);
  }
  translate(key: string) {
    if (typeof key != "undefined" && key != null) {
      var k = key.replace("Translation.", "");

      if (this.translationsService.translations[k]) {
        return this.translationsService.translations[k];
      } else {
        return key;
      }
    }

    return key;
  }

  focusOut(value: any) {
    if (this.pickerOpen) {
      return;
    }

    try {
      if (typeof value != "undefined") {
        if (value.isUtcOffset() == false) {
          let newDate = new Date(this.value);
          console.log("Timezone Offset: ", newDate.getTimezoneOffset());
          newDate.setMinutes(
            newDate.getMinutes() - newDate.getTimezoneOffset(),
          );
          this.value = moment(newDate).toJSON();
        } else {
          this.value = value.utc().toJSON();
        }
      }
    } catch {}

    if (!this.el?.nativeElement) return;
    const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
    input.blur();
  }
}
